"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _knock = require("../../../actions/knock");
var _user = require("../../../utils/user");
function directorRequestAnswered(_ref, payload) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  if ((0, _user.hasRealTimeCollaborationAccess)(getState)) {
    dispatch((0, _knock.clearDirectorRequest)(payload));
  }
}
var _default = exports["default"] = directorRequestAnswered;